var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Streitwert",
              property: "amountDispute",
              required: "",
              type: "currency",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Streitwert-Faktor",
              property: "feeFactor",
              required: "",
              type: "autocomplete",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-6",
            attrs: {
              "form-context": _vm.formContext,
              label: "Berechnung nach",
              property: "calculationMethod",
              required: "",
              type: "autocomplete",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsdatum",
              property: "dateReceipt",
              required: "",
              type: "date",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-6",
            attrs: {
              "form-context": _vm.formContext,
              label: "Zusatztext Gebührenposition",
              property: "additionalPositionText",
              type: "text",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }